export default __webpack_public_path__ + "static/media/PWRS.139ea846.png";